
import CONSTANTES from '../constantes';
import { takeEvery, call,put } from 'redux-saga/effects'
import { actionPutCategorias, actionAddCategoria, actionPutCatalogo } from '../acciones/accionesCatalogo';
import {message} from 'antd'
const axios = require('axios');


const getcategorias=() => fetch(`${CONSTANTES.URL_API}/panel/categorias/`,{
  method:'GET',
}).then(response=> response.json());

function* sagasGetCategorias(values) {
  try {

    const categorias = yield call(getcategorias);
    if (categorias) {
      yield put(actionPutCategorias(categorias))
    }

  } catch (error) {

    console.log(error)
  } 
}

const registroCategoria = (datos) => fetch(`${CONSTANTES.URL_API}/panel/categorias/`,
  {
    method: 'POST',
    body: JSON.stringify(datos),
    headers: new Headers({
      'Content-Type': 'application/json'
    })
  })
  .then(response => {
    return response.json()
  })
  .catch(e => {
    console.log(e)
  })

function* sagasAgregarCategoria(values) {
    try {
    console.log(values.values)
      let datoCategoria=values.values
      const categoria = yield call(registroCategoria, datoCategoria);
      console.log(categoria)
      if (categoria) {
        yield put(actionAddCategoria(categoria))
      }
  
    } catch (error) {
      console.log(error)
    }
  }



const getCatalogo = () => fetch(`${CONSTANTES.URL_API}/panel/catalogo/`,
  {
    method: 'GET',
    headers: new Headers({
      //'Authorization': 'Token ' + token,
      'Content-Type': 'application/json'
    })
  })
  .then(response => response.json())
  .catch(e => {
  })


function* sagasGetCatalogo(values) {
  try {

    let catalogo = yield call(getCatalogo);
    if (catalogo) {
      yield put(actionPutCatalogo(catalogo))
    }

  } catch (error) {

    console.log(error)
  }
}

const registroProducto = (producto) =>axios({
  method: 'POST',
  url: `${CONSTANTES.URL_API}/panel/catalogoPost/`,
  data:JSON.stringify(producto),
  headers: {
      'Content-Type': 'application/json'
  }

})
.then(function (response) {
  return response
})
.catch(error=>  {
  return error.response
});


function* sagasRegistroProducto(values) {
  try {
    let producto = yield call(registroProducto, values.values);
    if(producto.status!==400){
      let catalogo = yield call(getCatalogo);
      yield put(actionPutCatalogo(catalogo))
      message.success("Producto registrado");
    }
    else{
   
      message.error("Error al registrar el producto");
    }
  } catch (e) {
    console.log(e)
  }
}


  
const EditarProducto=(idProducto,producto)=> fetch(`${CONSTANTES.URL_API}/panel/catalogoPost/${idProducto}/`,
{
  method: 'PATCH',
  body:JSON.stringify(producto),
  headers: new Headers({
    'Content-Type': 'application/json'
})
})
.then(response=>{
    return response.json()
  })
  .catch(e=>{
    console.log(e)
  })

  function* sagasEditarProducto(values) {
    try {
      let producto=values.values
      let productoEdit=yield call(EditarProducto, values.idProducto, producto)
      console.log(productoEdit)
      if(productoEdit){
        let catalogo = yield call(getCatalogo);
        if (catalogo) {
          yield put(actionPutCatalogo(catalogo))
        }
        message.success("Producto editado");
      } 
      else{
       message.error("Error al editar Producto");
      }
     
    } catch (error) {
      console.log(error)
    }
  }


export default function* SagasCatalogo() {
    yield takeEvery(CONSTANTES.GET_CATEGORIAS, sagasGetCategorias)
    yield takeEvery(CONSTANTES.AGREGAR_CATEGORIA, sagasAgregarCategoria)
    yield takeEvery(CONSTANTES.GET_CATALOGO, sagasGetCatalogo)
    yield takeEvery(CONSTANTES.AGREGAR_PRODUCTO, sagasRegistroProducto) 
    yield takeEvery(CONSTANTES.EDITAR_PRODUCTO, sagasEditarProducto)
}